import React, { useMemo, useState } from 'react';

import { useScreenDispatch, useScreenState } from '@gogame/screens';

import {
  SET_COLOR_SCALES_ALL_COLUMNS,
  SET_COLUMNS,
  APPLY,
} from 'scenes/Trackers/Tracker/reducers';

import { CohortSettings } from '../CohortSettings';
import TrackerColumnPicker from '../TrackerColumnPicker';
import Actions from './Actions';
import { VIEW_AS_COHORT } from './constants';

window.dataLayer = window.dataLayer || [];

const TrackerActions = ({
  onExport,
  onExportGoogleDrive,
  onExportWhenReady,
  onOpenSubscriptionsForm,
  accentExport,
  disabledExport,
  disabledAdvancedFilters,
  disabledCustomizeColumns,
  setContent,
}) => {
  const [openArea, setOpenArea] = useState(null);
  const dispatch = useScreenDispatch();
  const screenState = useScreenState();

  const handleShowColorScales = async () => {
    setOpenArea(null);
    window.dataLayer.push({
      event: 'colorScaled',
      colorScaledMetric: 'all',
    });

    await dispatch({
      type: SET_COLOR_SCALES_ALL_COLUMNS,
      payload: true,
    });
  };

  const handleHideColorScales = async () => {
    setOpenArea(null);
    await dispatch({
      type: SET_COLOR_SCALES_ALL_COLUMNS,
      payload: false,
    });
  };

  const handleCustomizeColumns = () => {
    const { columns } = screenState.temporary || screenState;
    setOpenArea(null);
    setContent(TrackerColumnPicker, {
      value: columns.order,
      onSubmit: ({ order, apply }) => {
        const action = {
          type: SET_COLUMNS,
          payload: order,
        };
        if (apply) {
          dispatch({
            type: APPLY,
            payload: action,
          });
        } else {
          dispatch(action);
        }
      },
    });
  };

  const handleToggleCohortView = () => {
    const open = openArea === VIEW_AS_COHORT;
    setOpenArea(open ? null : VIEW_AS_COHORT);
    if (open) {
      setContent(null);
    } else {
      setContent(CohortSettings, {
        initialValues: { ...screenState.cohortsSettings },
        onClose: () => {
          setContent(null);
          setOpenArea(null);
        },
      });
    }
  };

  const isCohortMode = useMemo(() => {
    return Boolean(screenState.cohortsSettings.metric);
  }, [screenState.cohortsSettings]);

  return (
    <Actions
      openArea={openArea}
      colorScaled={screenState?.columns?.isAllScaled}
      onExport={onExport}
      onExportGoogleDrive={onExportGoogleDrive}
      onExportWhenReady={onExportWhenReady}
      onOpenSubscriptionsForm={onOpenSubscriptionsForm}
      onShowColorScales={handleShowColorScales}
      onHideColorScales={handleHideColorScales}
      disabledExport={disabledExport}
      disabledAdvancedFilters={disabledAdvancedFilters}
      disabledCustomizeColumns={disabledCustomizeColumns}
      accentExport={accentExport}
      isCohortMode={isCohortMode}
      onCustomizeColumns={handleCustomizeColumns}
      onToggleCohortView={handleToggleCohortView}
    />
  );
};

export default TrackerActions;
